(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.fabricSwatchPreviewReady) return;
    window.fabricSwatchPreviewReady = true;

    let dialog;
    function getDialog() {
      if (dialog) return dialog;
      dialog = document.createElement('dialog');
      dialog.className = 'fabric-preview-dialog';
      dialog.setAttribute('aria-label', 'Fabric close-up');
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'fabric-preview-dialog__close';
      close.textContent = 'Close';
      close.addEventListener('click', () => dialog.close());
      const image = document.createElement('img');
      image.className = 'fabric-preview-dialog__image';
      image.alt = '';
      const caption = document.createElement('p');
      caption.className = 'fabric-preview-dialog__caption';
      dialog.append(close, image, caption);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      document.body.append(dialog);
      return dialog;
    }

    document.addEventListener('click', (event) => {
      const label = event.target.closest('variant-picker label[data-fabric-preview-src]');
      if (!label) return;
      const preview = getDialog();
      const name = label.dataset.fabricPreviewName || 'Fabric';
      preview.querySelector('img').src = label.dataset.fabricPreviewSrc;
      preview.querySelector('img').alt = name + ' fabric close-up';
      preview.querySelector('p').textContent = name;
      if (!preview.open) preview.showModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
